var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useI18n } from '@wordpress/react-i18n';
// import "react-datepicker/dist/react-datepicker.css";
import React, { useEffect, useState } from 'react';
import qForminator from '@assets/gql/forminator.gql';
import { useQuery } from '@apollo/client';
import { ControlWrap } from '@assets/spa/control/wrap';
import './forminator.scss';
import { Modal } from '@assets/tsx/modal';
import OutsideAlerter from '@assets/tsx/outsideClicker';
import { AlertCard } from '@assets/tsx/alert';
import { isVisible } from './forminator.conditions';
import client from '@gql/client';
import Turnstile from 'react-turnstile';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import { ForminatorAddress, ForminatorNumber, ForminatorText, ForminatorSelect, ForminatorEmail, ForminatorPhone, ForminatorTextarea, ForminatorCheckbox, ForminatorRadio, ForminatorDate, ForminatorSection, ForminatorTime, ForminatorUpload, ForminatorConsent, ForminatorCurrency } from './fields';
const controlMap = {
    'text': ForminatorText,
    'number': ForminatorNumber,
    'url': ForminatorText,
    'name': ForminatorText,
    'select': ForminatorSelect,
    'email': ForminatorEmail,
    'phone': ForminatorPhone,
    'textarea': ForminatorTextarea,
    'checkbox': ForminatorCheckbox,
    'address': ForminatorAddress,
    'radio': ForminatorRadio,
    'date': ForminatorDate,
    'time': ForminatorTime,
    'section': ForminatorSection,
    'upload': ForminatorUpload,
    'consent': ForminatorConsent,
    'currency': ForminatorCurrency,
};
export default function Forminator(props) {
    if (!(props === null || props === void 0 ? void 0 : props.form_id))
        return React.createElement(React.Fragment, null, "Nenurodyta forma");
    return React.createElement(ForminatorForm, Object.assign({}, props));
}
function ForminatorForm({ form_id, prefetch }) {
    const { __ } = useI18n();
    const [formData, setFormData] = useState({});
    const [parsedMeta, setParsedMeta] = useState({});
    const { data, loading } = useQuery(qForminator, { variables: { id: form_id }, skip: !form_id, client });
    const [token, setToken] = useState(null);
    const [alert, setAlert] = useState();
    const [errors, setErrors] = useState({});
    const [submitting, setSubmiting] = useState(false);
    const [formDefaults, setFormDefaults] = useState({});
    const [rows, setRows] = useState({});
    const [rowOrder, setRowOrder] = useState([]);
    const [formRef, setFormRef] = useState();
    useEffect(() => {
        if (!(data === null || data === void 0 ? void 0 : data.forminatorForm))
            return;
        const formProps = JSON.parse(data.forminatorForm.unparsedMeta || '{}');
        const fields = formProps['fields'];
        const prefill = {};
        const rowObj = {};
        const order = [];
        fields && fields.length > 0 && fields.map((field) => {
            const { form_id } = field;
            if (!rowObj[form_id])
                rowObj[form_id] = [];
            rowObj[form_id].push(field);
            if (!order.includes(form_id))
                order.push(form_id);
            if (field.type === 'checkbox') {
                const defaultCboxes = [];
                field.options.map((cbox) => {
                    if (cbox.default === '1')
                        defaultCboxes.push(cbox.value);
                });
                if (defaultCboxes.length > 0)
                    prefill[field.id] = defaultCboxes;
            }
        });
        setRows(rowObj);
        setRowOrder(order);
        setFormData(prefill);
        setFormDefaults(prefill);
        setParsedMeta(formProps);
    }, [data]);
    const { fields, settings } = parsedMeta;
    const submitData = (settings === null || settings === void 0 ? void 0 : settings.submitData) || {};
    function fetchFreshNonce(fid) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'forminator_get_nonce',
                    form_id: String(fid),
                }),
            });
            const json = yield res.json().catch(() => null);
            const nonce = String((json === null || json === void 0 ? void 0 : json.data) || '').trim();
            return nonce;
        });
    }
    function onSubmit(ev) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            ev.preventDefault();
            if (submitting)
                return;
            if (!token) {
                setAlert({ status: 'danger', title: __('Pažymėkite "Nesu robotas"', 'ltg-widgets') });
                return;
            }
            const { form_id, form_type, forminator_nonce } = (_a = data === null || data === void 0 ? void 0 : data.forminatorForm) === null || _a === void 0 ? void 0 : _a.hiddenFields;
            const submitData = new FormData();
            let invalidFields = {};
            fields && fields.map((field) => {
                var _a, _b;
                const value = formData[field.id];
                const visible = isVisible(formData, field.condition_rule, field.conditions, field.condition_action);
                if (!visible)
                    return;
                const checkRequired = (_a = controlMap[field.type]) === null || _a === void 0 ? void 0 : _a.checkRequired;
                if (checkRequired) {
                    const errors = checkRequired(field, formData, __);
                    if (Object.keys(errors).length) {
                        invalidFields = Object.assign(Object.assign({}, invalidFields), errors);
                        return;
                    }
                }
                else if (field.required === '1' && !value) {
                    invalidFields[field.id] = field.required_message || __('Privalomas laukas', 'ltg-widgets');
                    return;
                }
                const validate = (_b = controlMap[field.type]) === null || _b === void 0 ? void 0 : _b.validate;
                if (field.validation === "1" && validate) {
                    const isValid = validate(value);
                    if (!isValid) {
                        invalidFields[field.id] = field.validation_message;
                        return;
                    }
                }
                const childFields = Object.keys(formData).filter(fid => fid.length !== field.id.length && fid.indexOf(field.id) === 0);
                if (childFields.length) {
                    childFields.forEach(cfId => { submitData.set(cfId, formData[cfId]); });
                }
                else {
                    if (Array.isArray(value)) {
                        value.forEach((file) => {
                            submitData.append(`${field.id}[]`, file);
                        });
                    }
                    else {
                        submitData.set(field.id, value || '');
                    }
                }
            });
            const newNonce = yield fetchFreshNonce(form_id);
            if (!newNonce) {
                setAlert({ status: 'danger', title: 'Nepavyko gauti nonce (empty). Žiūrėk console.' });
                return;
            }
            if (Object.keys(invalidFields).length > 0) {
                setErrors(invalidFields);
                return;
            }
            setSubmiting(true);
            submitData.set('forminator_nonce', newNonce);
            submitData.set('current_url', `${window.location.origin}${window.location.pathname}`);
            submitData.set('form_id', form_id);
            submitData.set('form_type', form_type);
            submitData.set("action", "forminator_submit_form_custom-forms");
            submitData.append('cf-turnstile-response', token);
            submitData.append('cf-turnstile', token);
            submitData.append('turnstile_response', token);
            try {
                formRef && formRef.scrollIntoView({ behavior: 'smooth' });
                const response = yield fetch('/wp-admin/admin-ajax.php', { method: 'POST', body: submitData }).then(res => res.json());
                setSubmiting(false);
                setToken(undefined);
                (_b = window === null || window === void 0 ? void 0 : window.turnstile) === null || _b === void 0 ? void 0 : _b.reset();
                if (response.success && response.data.message) {
                    setAlert({
                        status: 'success',
                        title: React.createElement("div", { dangerouslySetInnerHTML: { __html: response.data.message } }),
                    });
                    // setMessage(response.data.message)
                    setTimeout(() => {
                        setAlert(undefined);
                        // setMessage(undefined);
                    }, response.data.fadeout_time || 10000);
                    setFormData(formDefaults);
                }
                else if (!response.success) {
                    const errors = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d.reduce((agr, err) => (Object.assign(Object.assign({}, agr), err)), {});
                    ((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.message) && setAlert({ status: 'danger', title: React.createElement("div", { dangerouslySetInnerHTML: { __html: response.data.message } }) });
                    errors && setErrors(errors);
                }
            }
            catch (err) {
                setSubmiting(false);
                setAlert({ title: "Serverio klaida", status: 'danger' });
            }
        });
    }
    if (fields === null || fields === void 0 ? void 0 : fields.length)
        return React.createElement(React.Fragment, null,
            React.createElement("form", { ref: setFormRef, onSubmit: onSubmit, className: `ltg-forminator-form${submitting ? ' --submitting' : ''}` },
                React.createElement("div", { className: "ltg-forminator-fields" }, rowOrder.map((formId) => {
                    const fields = rows[formId];
                    return React.createElement("div", { className: 'ltg-forminator-row', key: formId }, fields.map((props) => {
                        const { id, type, cols, field_label, required, required_message, description, validation_message, validation, conditions, condition_rule, condition_action } = props;
                        const ForminatorControl = controlMap[type];
                        if (!ForminatorControl)
                            return React.createElement("h2", { key: id, style: { gridColumn: `auto / span 12` } },
                                "Neapdorotas inputas : ",
                                type,
                                React.createElement(XLOG, { data: props }));
                        const value = formData[id];
                        const onChange = (value, custom_id) => {
                            if (submitting)
                                return;
                            setErrors(prev => {
                                delete prev[custom_id || id];
                                return prev;
                            });
                            if (ForminatorControl.mask) {
                                value = ForminatorControl.mask(value);
                            }
                            setFormData(prev => (Object.assign(Object.assign({}, prev), { [custom_id || id]: value })));
                        };
                        const onValidate = (value) => {
                            if (validation !== "1")
                                return;
                            if (!ForminatorControl.validate)
                                return;
                            const valueValid = !value ? true : ForminatorControl.validate(value);
                            if (!valueValid)
                                setErrors(prev => (Object.assign(Object.assign({}, prev), { [id]: validation_message })));
                            if (valueValid) {
                                if (required === "1" && !value) {
                                    setErrors(prev => (Object.assign(Object.assign({}, prev), { [id]: required_message })));
                                }
                                else {
                                    setErrors(prev => {
                                        delete prev[id];
                                        return prev;
                                    });
                                }
                            }
                        };
                        const message = errors[id];
                        const isValid = !message;
                        let visible = true;
                        if ((conditions === null || conditions === void 0 ? void 0 : conditions.length) > 0) {
                            visible = isVisible(formData, condition_rule, conditions, condition_action);
                        }
                        if (!visible)
                            return null;
                        return React.createElement("div", { className: "ltg-forminator-field", key: id },
                            React.createElement(ControlWrap, { label: field_label, valid: isValid, message: message, required: required === '1' },
                                React.createElement(ForminatorControl, Object.assign({}, Object.assign(Object.assign({}, props), { value, errors, setErrors, onChange, onValidate, values: formData, countries: prefetch === null || prefetch === void 0 ? void 0 : prefetch.countries }))),
                                description &&
                                    React.createElement("div", { className: "ltg-forminator-field-desc" }, description)));
                    }));
                })),
                React.createElement("div", null,
                    React.createElement(Turnstile, { onVerify: (token) => { setToken(token); }, sitekey: prefetch === null || prefetch === void 0 ? void 0 : prefetch.turnstile_sitekey })),
                isVisible(formData, submitData.condition_rule, submitData.conditions, submitData.condition_action) && React.createElement("div", null,
                    React.createElement("button", { className: 'btn' }, submitData['custom-submit-text'] || 'Pateikti'))),
            React.createElement(Modal, { open: !!alert },
                React.createElement(OutsideAlerter, { callback: () => { setAlert(undefined); } },
                    React.createElement(AlertCard, { status: alert === null || alert === void 0 ? void 0 : alert.status, title: alert === null || alert === void 0 ? void 0 : alert.title, message: alert === null || alert === void 0 ? void 0 : alert.message, onConfirm: () => { setAlert(undefined); } }))));
    return React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 10 } }, new Array(4).fill('').map((_, i) => {
        return React.createElement("div", { key: i },
            React.createElement(LoadingBox, { style: { height: 10, marginBottom: 2, width: '35%' } }),
            React.createElement(LoadingBox, { style: { height: 40 } }));
    }));
}
// ForminatorCurrency.mask = (value:string) => value.replace(/[^0-9.,]/g, '')
function XLOG({ data }) {
    const [open, setOpen] = useState(false);
    return React.createElement(React.Fragment, null,
        React.createElement("span", { style: { cursor: 'pointer', color: 'purple' }, onClick: () => { setOpen(!open); } }, "xlog:"),
        open && React.createElement("pre", null, JSON.stringify(data, null, 3)));
}
